import Swal from 'sweetalert2';

const Toast = Swal.mixin({
  toast: true,
  position: 'bottom-end',
  showConfirmButton: false,
  timer: 3500,
  timerProgressBar: true,
  didOpen: (toastEl) => {
    toastEl.addEventListener('mouseenter', Swal.stopTimer);
    toastEl.addEventListener('mouseleave', Swal.resumeTimer);
  },
});

export function toastSuccess(message) {
  Toast.fire({ icon: 'success', title: message });
}

export function toastError(message) {
  Toast.fire({ icon: 'error', title: message, timer: 5000 });
}

export function toastWarning(message) {
  Toast.fire({ icon: 'warning', title: message, timer: 4500 });
}

export function toastInfo(message) {
  Toast.fire({ icon: 'info', title: message });
}

export function toastNotification(title, onClick) {
  Toast.fire({
    icon: 'info',
    title,
    timer: 6000,
    didOpen: (toastEl) => {
      toastEl.addEventListener('mouseenter', Swal.stopTimer);
      toastEl.addEventListener('mouseleave', Swal.resumeTimer);
      if (onClick) {
        toastEl.style.cursor = 'pointer';
        toastEl.addEventListener('click', onClick);
      }
    },
  });
}

export default { toastSuccess, toastError, toastWarning, toastInfo, toastNotification };
